<template>
  <e-table
    ref="table"
    name="warehouse-order"
    :items="items"
    :coreColumnDefs="coreColumnDefs"
    :defaultSort="{}"
    :virtual="true"
    :rowHeight="35"
    :getHeight="getHeight"
  />
</template>
<script>
import Vue from "vue";

Vue.component("warehouse-order-id", {
  props: { item: Object, options: Object },
  template: `
     <popup componentPath="components/html" width="900px" :pivot-y=0 :options="viewOrderOptions(item.id)">
      {{item.id}}
    </popup>
  `,
});

Vue.component("warehouse-order-priority", {
  props: { item: Object, options: Object },
  template: `
    <container-priority :item="item" />
  `,
});

Vue.component("warehouse-order-notification", {
  props: { item: Object, options: Object },
  template: `
    <div v-if="item.notification.enabled">
      <div>{{item.notification.time}}</div>
      <slot v-if="!item.notification.time">
        <el-button size="mini" type="success" class="micro" @click="notify(item)">
          Notify
        </el-button>
      </slot>
    </div>
  `,
  methods: {
    async notify() {
      try {
        await this.$confirm(
          `Are you sure you want to notify the customer/dispatcher that the container is ready to pickup?`,
          "Confirmation",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "warning",
          },
        );
        const response = await this.$http.post(
          `/api/v1/warehouses/${this.item.id}/notify`,
        );
        this.item = response.data;
      } catch (e) {
        console.error(e);
      }
    },
  },
});

import api from "@/default/utils/api";
export default {
  name: "ContainerWarehouseTable",
  mixins: [api],
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      height: 0,
      coreColumnDefs: [
        {
          title: "ID",
          field: "id",
          width: 64,
          fixed: "left",
          component: "warehouse-order-id",
        },
        {
          title: "Hub",
          field: "hub.name",
          width: 96,
          component: "ve-table-column",
        },
        {
          title: "Type",
          field: "abbrev_type",
          width: 50,
          component: "ve-table-column",
        },
        {
          title: "Customer",
          field: "customer.name",
          width: 150,
          component: "ve-table-column",
        },
        {
          title: "Container No.",
          field: "container_no",
          width: 110,
          component: "ve-table-column",
        },
        {
          title: "Size/Type",
          field: "ctype",
          width: 80,
          component: "ve-table-column",
        },
        {
          title: "SSLine",
          field: "ssline.name",
          width: 150,
          component: "ve-table-column",
        },
        {
          title: "Refer. No.",
          field: "reference_no",
          width: 120,
          component: "ve-table-column",
        },
        {
          title: "Latest Event",
          field: "trace.terminal.move_event.status",
          key: "latest-event",
          width: 150,
          component: "ve-table-column",
        },
        {
          title: "Event Location",
          field: "trace.terminal.move_event.location.city",
          key: "event-location",
          width: 150,
          component: "ve-table-column",
        },
        {
          title: "PCS",
          field: "piece_count",
          width: 80,
          component: "ve-table-column",
        },
        {
          title: "Weight",
          field: "weight",
          width: 80,
          component: "ve-table-column",
        },
        {
          title: "Appt. Date",
          field: "appt_date",
          path: "dates.appt",
          width: 120,
          component: "ve-table-column",
        },
        {
          title: "Appt. Time",
          field: "appt_start",
          path: "appt_time",
          width: 120,
          component: "ve-table-column",
        },
        {
          title: "PRI",
          field: "priority.value",
          width: 50,
          aliasName: "Priority",
          classes: "cell-style",
          component: "warehouse-order-priority",
        },
        {
          title: "Drop Date",
          field: "dwell_drop",
          path: "dwell.drop",
          width: 85,
          aliasName: "Drop Date",
          component: "ve-table-column",
        },
        {
          title: "Dwell Days",
          field: "dwell_days",
          path: "dwell.days",
          width: 90,
          aliasName: "Days",
          component: "ve-table-column",
        },
        {
          title: "PD LFD",
          field: "per_diem_lfd",
          path: "dates.pd_lfd",
          width: 65,
          aliasName: "Per Diem LFD",
          component: "ve-table-column",
        },
        {
          title: "Empty/Loaded",
          field: "notification.time",
          width: 120,
          component: "warehouse-order-notification",
        },
        {
          title: "Terminal",
          field: "terminal.name",
          width: 150,
          component: "ve-table-column",
        },
        {
          title: "Term. ETA",
          field: "terminal_eta",
          path: "dates.eta",
          width: 85,
          aliasName: "Term. ETA",
          component: "ve-table-column",
        },
        {
          title: "Term. LFD",
          field: "rail_lfd",
          path: "dates.lfd",
          width: 85,
          aliasName: "Term. LFD",
          component: "ve-table-column",
        },
        {
          title: "ERD",
          field: "early_receiving_date",
          path: "dates.erd",
          width: 65,
          aliasName: "Early Receiving Date",
          component: "ve-table-column",
        },
        {
          title: "COD",
          field: "rail_cutoff_date",
          path: "dates.cod",
          width: 65,
          aliasName: "Cut Off Date",
          component: "ve-table-column",
        },
        {
          title: "Return",
          field: "returned_date",
          path: "dates.rtn",
          width: 65,
          aliasName: "Return Date",
          component: "ve-table-column",
        },
        {
          title: "Vendor",
          field: "vendor",
          width: 80,
          component: "ve-table-column",
        },
      ],
    };
  },
  async mounted() {
    await this.loadEnvs();
    this.initCachedColumns();
  },
  methods: {
    getHeight() {
      return document.querySelector("#app > .content").offsetHeight - 120;
    },
    scrollTop() {
      this.$refs.table.$refs.utable.pagingScrollTopLeft(0, 0);
    },
    initCachedColumns() {
      const tableName = "warehouse-order";
      this.$actions.renameTableColumn(tableName, "ETA", "Term. ETA");
      this.$actions.renameTableColumn(tableName, "Last Free Day", "Term. LFD");
      this.$actions.renameTableColumn(
        tableName,
        "Per Diem Last Free Day",
        "Per Diem LFD",
      );
      const columns = [
        "ID",
        "Hub",
        "Type",
        "Customer",
        "Container No.",
        "Size/Type",
        "PCS",
        "Weight",
        "SSLine",
        "Refer. No.",
        "Latest Event",
        "Event Location",
        "Appt. Date",
        "Appt. Time",
        "Priority",
        "Drop Date",
        "Dwell Days",
        "Per Diem LFD",
        "Empty/Loaded",
        "Terminal",
        "Term. ETA",
        "Term. LFD",
        "Early Receiving Date",
        "Cut Off Date",
        "Return Date",
        "Vendor",
      ];

      this.initTableColumns(tableName, columns);
      this.$emit("initColumnOptions");
    },
  },
};
</script>
